import React, { useCallback, useRef, useEffect, useState } from 'react';

import { IconType } from 'react-icons';
import { Feira, Expositor, Container } from '../../styles';
import { ContactIcons } from '../../../../components/Menu';
import { urlWebsite } from '../../../../config';
import api from '../../../../services/api';
import { Button } from '../../../../components/Button/styles';
import { Form } from '@unform/web';
import { useSearch } from '../../../../hooks/Search';
import { useAuth } from '../../../../hooks/Auth';
import QrReader from 'react-qr-reader';
import CheckinQRList from '../../../DashboardPages/features/CheckinQRList';
import { FaCheckCircle } from 'react-icons/fa';
import { useToast } from '../../../../hooks/Toast';
import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { useLoading } from 'src/hooks/LoadingHook';

interface IPublicData {
    icon: IconType;
    title: string;
    text: string;
}

interface IExpositor {
    id: number;
    background: string;
    capa: string;
    title: string;
    link_name: string;
}

const QRCodeCreator: React.FC = () => {
    const { user } = useAuth();
    const { addLoading, removeLoading } = useLoading();
    const [type, setType] = useState('waiting');
    const [qrcode, setQrcode] = useState('waiting');
    /* status
    waiting
    qrcode
    
    */

    const { addToast } = useToast();

    const createQRCode = async () => {
        addLoading({ title: 'Carrgando', key: 'loading' })
        try {

            const hash = uuid();
            await api.post(`/create-preorder/${hash}`);
            setQrcode(hash);
            setType('qrcode');
            removeLoading('loading')
        }
        catch (err) {
            removeLoading('loading');
            addToast({ title: err?.response?.data?.message || err?.responde?.data?.error || 'Erro ao criar QRCode' })
        }


    }

    if (!user) {
        return <Container>
            <h2>Área restrita</h2>
        </Container>
    }


    if (type === 'waiting') {
        return <Container>
            <h2>Clique no botão abaixo para criar um QRCode</h2>

            <button className='greenButton2' style={{ padding: '15px', margin: '15px auto' }} onClick={() => createQRCode()}>Criar</button>
        </Container>
    }


    if (type === 'qrcode') {
        return <Container>
            <h2>Leia o QRCode abaixo para validar sua presença</h2>

            <div style={{ width: '100%', justifyContent: 'center', display: 'flex', padding: '30px' }}>
                <div style={{ padding: '20px', background: '#fff', borderRadius: '10px' }}>
                    <QRCode
                        size={240}
                        value={`${urlWebsite}/validar-presenca/${qrcode}`} renderAs="svg" />
                </div>
            </div>
            <p>{`${urlWebsite}/validar-presenca/${qrcode}`}</p>
            <button style={{ padding: '15px', margin: '15px auto' }} className='greenButton2' onClick={() => {
                setType('waiting');
                setQrcode('');


            }}>Voltar</button>
        </Container>
    }

    return <></>
};
export default QRCodeCreator;
